(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["heir-featured-vintage"] && !Shopify.designMode) return;
  try {
    
(() => {
  function initializeMosaic() {
    document.querySelectorAll('[data-featured-rug]').forEach((details) => {
      if (details.dataset.mosaicReady) return;
      details.dataset.mosaicReady = 'true';
      const summary = details.querySelector('summary');
      let pinned = false;
      let suppressFocus = false;
      function close() { details.open = false; pinned = false; }
      function open() {
        document.querySelectorAll('[data-featured-rug][open]').forEach((other) => {
          if (other !== details) other.open = false;
        });
        details.open = true;
      }
      details.addEventListener('toggle', () => { if (!details.open) pinned = false; });
      summary.addEventListener('click', (event) => {
        event.preventDefault();
        pinned = !pinned;
        if (pinned) open(); else close();
      });
      summary.addEventListener('focus', () => {
        if (!suppressFocus) open();
      });
      details.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'mouse') open();
      });
      details.addEventListener('pointerleave', (event) => {
        if (event.pointerType === 'mouse' && !pinned && !details.contains(document.activeElement)) close();
      });
      details.addEventListener('focusout', (event) => {
        if (!details.contains(event.relatedTarget)) close();
      });
      details.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        event.preventDefault();
        close();
        suppressFocus = true;
        summary.focus();
        suppressFocus = false;
      });
      document.addEventListener('click', (event) => {
        if (!details.contains(event.target)) close();
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeMosaic);
  else initializeMosaic();
  document.addEventListener('shopify:section:load', initializeMosaic);
})();
(() => {
  const panels = () => document.querySelectorAll('[data-featured-guidance-panel]');
  const formFor = (panel) => panel.querySelector('.heir-featured__guidance-form');
  function reveal(panel, focus) {
    const form = formFor(panel);
    if (!form) return;
    panel.open = true;
    form.scrollIntoView({ block: 'start' });
    if (focus) form.querySelector('[name="contact[name]"]')?.focus({ preventScroll: true });
  }
  function restoreHash() {
    panels().forEach((panel) => {
      const form = formFor(panel);
      if (form && window.location.hash === '#' + form.id) reveal(panel, false);
    });
  }
  function resetSubmit(panel) {
    const form = formFor(panel);
    if (!form) return;
    delete form.dataset.sending;
    form.removeAttribute('aria-busy');
    const submit = form.querySelector('[type="submit"]');
    if (submit) {
      submit.disabled = false;
      submit.textContent = 'Prepare my request';
    }
    const status = form.querySelector('[data-heir-guidance-status]');
    if (status) status.textContent = '';
  }
  function initializeGuidance() {
    panels().forEach((panel) => {
      if (panel.dataset.featuredGuidanceReady) return;
      const root = panel.closest('.heir-featured');
      const form = formFor(panel);
      const trigger = root?.querySelector('[data-featured-guidance-trigger]');
      if (!form || !trigger) return;
      panel.dataset.featuredGuidanceReady = 'true';
      resetSubmit(panel);
      const syncExpanded = () => trigger.setAttribute('aria-expanded', String(panel.open));
      const clearHash = () => {
        if (window.location.hash === '#' + form.id) {
          window.history.replaceState(window.history.state, '', window.location.pathname + window.location.search);
        }
      };
      syncExpanded();
      panel.addEventListener('toggle', () => {
        syncExpanded();
        if (!panel.open) clearHash();
      });
      trigger.addEventListener('click', (event) => {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        if (window.location.hash !== '#' + form.id) {
          window.history.replaceState(window.history.state, '', '#' + form.id);
        }
        reveal(panel, true);
        syncExpanded();
      });
      panel.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape' || !panel.open) return;
        event.preventDefault();
        panel.open = false;
        syncExpanded();
        clearHash();
        panel.querySelector('summary')?.focus();
      });
      form.addEventListener('submit', (event) => {
        if (event.defaultPrevented) return;
        const status = form.querySelector('[data-heir-guidance-status]');
        const trap = form.querySelector('.heir-html__honeypot');
        if (trap && trap.value.trim()) {
          event.preventDefault();
          if (status) status.textContent = 'Unable to send this request.';
          return;
        }
        if (!form.checkValidity()) {
          event.preventDefault();
          form.reportValidity();
          return;
        }
        if (form.dataset.sending === 'true') {
          event.preventDefault();
          return;
        }
        form.dataset.sending = 'true';
        form.setAttribute('aria-busy', 'true');
        const submit = form.querySelector('[type="submit"]');
        if (submit) {
          submit.disabled = true;
          submit.textContent = 'Sending request…';
        }
        if (status) status.textContent = 'Sending your request to the Heirlooms team.';
        queueMicrotask(() => { if (event.defaultPrevented) resetSubmit(panel); });
      });
      if (form.querySelector('[data-featured-guidance-result]')) panel.open = true;
      syncExpanded();
    });
    restoreHash();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeGuidance);
  else initializeGuidance();
  document.addEventListener('shopify:section:load', initializeGuidance);
  window.addEventListener('hashchange', restoreHash);
  window.addEventListener('pageshow', () => {
    panels().forEach(resetSubmit);
    restoreHash();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
	document.addEventListener('change', function(event) {
		if (!event.target.matches('[data-studio-edit-price-filter]')) return;

		const range = event.target.value;
		const cards = document.querySelectorAll('#product-grid > [data-collection-price]');

		cards.forEach(function(card) {
			const price = Number(card.dataset.collectionPrice);
			let visible = true;

			if (range === '0-200000') visible = price < 200000;
			if (range === '200000-500000') visible = price >= 200000 && price <= 500000;
			if (range === '500000-up') visible = price > 500000;

			card.hidden = !visible;
		});
	});

  } catch(e) { console.error(e); }
})();
})();
